import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CaptchaComponent } from 'angular-captcha';
import { ContactoService } from '../_services';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
var ContactoComponent = /** @class */ (function () {
    function ContactoComponent(formBuilder, contactoService, route, router) {
        this.formBuilder = formBuilder;
        this.contactoService = contactoService;
        this.route = route;
        this.router = router;
        this.submitted = false;
        this.loading = false;
        this.alerta = '';
        this.incrustado = false;
        this.nombre = '';
    }
    Object.defineProperty(ContactoComponent.prototype, "f", {
        get: function () {
            return this.contactoForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    ContactoComponent.prototype.ngOnInit = function () {
        this.contactoForm = this.formBuilder.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', Validators.required],
            comment: [''],
            captchaCode: [''],
            captchaId: ['']
        });
    };
    ContactoComponent.prototype.onSubmit = function () {
        var _this = this;
        this.submitted = true;
        if (this.contactoForm.invalid) {
            return;
        }
        this.loading = true;
        this.contactoForm.controls.captchaCode.setValue(this.captchaComponent.captchaCode);
        this.contactoForm.controls.captchaId.setValue(this.captchaComponent.captchaId);
        this.contactoService
            .postContacto(this.contactoForm.value)
            .pipe(first())
            .subscribe(function (data) {
            console.log('Mail enviado exitosamente');
            _this.submitted = true;
            _this.loading = false;
            _this.alerta = '';
            // reload Captcha image
            _this.captchaComponent.reloadImage();
            alert('Se envió exitosamente el correo de contacto.');
            _this.router.navigate(['/inicio']);
        }, function (error) {
            console.error(error);
            _this.alerta = error;
            _this.loading = false;
            _this.submitted = false;
            // reload Captcha image
            _this.captchaComponent.reloadImage();
        });
    };
    ContactoComponent.prototype.onClosed = function (dismissedAlert) {
        this.alerta = '';
    };
    return ContactoComponent;
}());
export { ContactoComponent };
